const EXISTING_VISA_STEP_INDEX = {
  // introduction: 0,
  selectVisa: 0,
  nodes: 1,
  result: 2, 
};

export default EXISTING_VISA_STEP_INDEX;
